import { render, staticRenderFns } from "./CustomerCompactDetailHeader.vue?vue&type=template&id=b1fb9746&lang=pug&"
import script from "./CustomerCompactDetailHeader.vue?vue&type=script&lang=js&"
export * from "./CustomerCompactDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCompactDetailHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports